export const globalConfig = {
  backendUrl: process.env.NEXT_PUBLIC_BACKEND_URL,
  frontendUrl: process.env.NEXT_PUBLIC_FRONTEND_URL,

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "G-TNP86D2QW2",
  },

  purchaseCredit: {
    checkoutSchedulerInterval: 1000 * 60 * 10, // 10 minutes
  },

  // okta auth config
  oktaConfig: {
    issuer: "https://ids.mlb.com/oauth2/aus1m088yK07noBfh356",
    clientId: "0oasmcdgh92Jom7TI357",
  },

  termsAndConditionPdfUrl:
    "https://www.attend.tech/terms-of-use",
  privacyPolicyPdfUrl:
    "https://www.attend.tech/privacy-policy",

  logOutVersion: "v1",
  cartCacheExpiry: 1000 * 60 * 20, // 20 minutes
};
